import { Button, Flex, Modal } from "@/atoms"
import { useModal } from "@/hooks/useModal"
import { PlusOutlined } from "@/icons"
import {
  FormSlack,
  TestSlackButton
} from "@/pages/IntegrationsPage/components/molecules/FormSlack"
import { ConnectIntegrationFooter } from "@/pages/IntegrationsPage/components/pages/ConnectIntegrationPage/ConnectIntegrationFooter"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { useSlackAPI } from "@/pages/IntegrationsPage/hooks/useSlackAPI"

import styles from "../ActionsSectionForm.module.scss"

import type { SlackChannelModalProps } from "./SlackChannelModal.types"

export const SlackChannelModal = ({
  label,
  disabled,
  onAdded
}: SlackChannelModalProps) => {
  const { visible, show, hide } = useModal()
  const [, formProps] = useIntegration({ vendor: "slack" })
  const { t, form } = formProps

  const close = () => {
    form.resetFields()
    hide()
  }

  const slackApi = useSlackAPI({
    ...formProps,
    onCreated: async (name) => {
      await onAdded(name)
      close()
    }
  })

  return (
    <>
      <Button
        className={styles.button}
        size="small"
        type="link"
        icon={<PlusOutlined />}
        disabled={disabled}
        onClick={show}
      >
        {label}
      </Button>
      <Modal
        title={label}
        open={visible}
        destroyOnClose
        onCancel={close}
        footer={
          <Flex flex={1} justify="space-between">
            <TestSlackButton
              form={form}
              t={t}
              onTest={slackApi.onTest}
              isTesting={slackApi.isTesting}
              isPending={slackApi.isPending}
            />
            <ConnectIntegrationFooter
              okText={t("integrations.slack.form.buttons.add")}
              isLoading={slackApi.isPending}
              okProps={{ form: slackApi.formId, htmlType: "submit" }}
              onCancel={close}
            />
          </Flex>
        }
      >
        <FormSlack
          {...formProps}
          formId={slackApi.formId}
          onFinish={slackApi.onFinish}
        />
      </Modal>
    </>
  )
}
